<template>
  <div class="slide-container" id="introslides">
    <div class="slide-sticky-back">
      <img class="img-fluid" src="@/assets/tavle-fade.png" /> 
    </div>
    <div class="slide-container-front" id="slide-container-front-1">
      <div class="container"> 
        <img class="savnet-logo" src="@/assets/savnet-logo.svg" />
        <img class="savnet-logo subtitle" src="@/assets/lapper_stikktittel.png" />
       </div> 

    </div>

    <div class="slide-container-front last" id="slide-container-front-2">
      <div class="container">
        <p class="text">Både familie og etterforskere frykter Reidar Sandanger ble drept. Så hvorfor gjorde ikke politiet i to land mer for å finne svar?</p>
      </div>
    </div>


  </div>
</template>

<script>
export default {
  name: "frontcover",
  components: {},
};
</script>
<style lang="scss">
.slide-container-front {
  position: relative;
  width: 100%;
  -webkit-transform: translate3d(0, 0, 1px);
  transform: translate3d(0, 0, 1px);
  z-index: 1000 !important;

  height: 100%;
  padding-bottom: 100vh;

  &.last {
    padding-bottom: 40vh;
  }

  h3 {
    color: #fff;
    font-size: 5em;
    font-family: "brixton";
    padding: 0;
    margin: 0;
  }
  .text {
    color: #fff;
    font-size: 1.5em;
    margin: 0;
    width: 80%;
    text-align: center;
    text-shadow: 0px 0px 10px black;
    @include desktop () {
      width: 40%;
    }

  }
}

.savnet-logo {
  width: 90%;
  max-width: 400px;
  &.subtitle {
    margin-top: -40px;
      @include desktop () {
        margin-top: -50px;
      }
  }
}

#slide-container-front-1 {
  margin-top: -50vh;
}


.slide-sticky-back {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  will-change: position;
  height: 100vh;
  overflow: hidden;
  width: 100%;
  margin: 0 auto;
  // z-index: -100 !important;
  //background: #000;
}
@keyframes fadeInZoom {
  from {
    opacity: 0;
    transform: scale(2);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.slide-sticky-back img,
slide-sticky-back video {
  -o-object-fit: cover;
  object-fit: cover;
  object-position: bottom;
  width: 100%;
  height: 100%;
  animation: fadeInZoom 4s ease-out forwards;
}

.img-fluid,
.img-thumbnail {
  max-width: 100%;
  height: auto;
  mask-image: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.65) 60%);
  -webkit-mask-image: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.65) 60%);

}

img,
svg {
  vertical-align: middle;
}


</style>